import { gql } from '@redwoodjs/web'

// Query to check applicant eligibility for background checks
export const GET_APPLICANTS_FOR_BACKGROUND_CHECK = gql`
  query ApplicantsForBackgroundCheck(
    $pageInfo: PageInfoInput
    $filters: ApplicantFiltersInput
  ) {
    applicants(pageInfo: $pageInfo, filters: $filters) {
      items {
        applicantId
        firstName
        lastName
        application {
          applicationId
          ssn
          dob
          license {
            licenseNumber
            state
          }
          addresses {
            addressId
          }
          consents {
            consentId
            signed
          }
        }
        address {
          addressId
        }
      }
    }
  }
`

export const GET_PACKAGE_ORDERS = gql`
  query GET_PACKAGE_ORDERS(
    $filters: PackageOrderFiltersInput
    $pageInfo: PageInfoInput
  ) {
    getPackageOrders(filters: $filters, pageInfo: $pageInfo) {
      items {
        packageOrderId
        createdAt
        updatedAt
        status
        orderType
        providerOrderId
        errorMessage
        providerResponse
        currentLicenseOnly
        activityLogs {
          activityDate
          activityLogId
          content
          createdAt
          endCallDate
          title
          type
          updatedAt
        }
        documents {
          category
          createdAt
          deletedAt
          documentId
          expirationDate
          fileName
          fileType
          isRenewed
          path
          status
          updatedAt
          uploadStatus
          uploadUrl
          userStatus
        }
        items {
          packageOrderItemId
          productType
          productName
          status
          completedAt
          providerResult
          providerResultDetails
        }
        completedDate
        applicant {
          applicantId
          firstName
          lastName
          email
          phone
        }
        package {
          packageId
          name
          description
        }
        recruiter {
          employeeId
          firstName
          lastName
          email
        }
        company {
          companyId
          companyName
        }
      }
      totalCount
    }
  }
`

export const CREATE_PACKAGE_ORDER = gql`
  mutation CREATE_PACKAGE_ORDER($input: CreatePackageOrderInput!) {
    createPackageOrder(input: $input) {
      packageOrderId
      providerOrderId
      status
      generatedWebLink
      errorMessage
      isDuplicated
    }
  }
`

export const GET_PACKAGE_ORDER_ENHANCED_REPORT = gql`
  query GET_PACKAGE_ORDER_ENHANCED_REPORT($packageOrderId: String!) {
    getPackageOrderEnhancedReport(packageOrderId: $packageOrderId) {
      url
    }
  }
`

export const GET_PACKAGE_ORDER_DRIVER_IQ_LEAD_TYPES = gql`
  query GET_PACKAGE_ORDER_DRIVER_IQ_LEAD_TYPES($packageOrderId: String!) {
    getPackageOrderDriverIQLeadTypes(packageOrderId: $packageOrderId) {
      verificationSource
      status
      result
    }
  }
`

export const BULK_CREATE_PACKAGE_ORDERS = gql`
  mutation BulkCreatePackageOrders($input: BulkCreatePackageOrderInput!) {
    bulkCreatePackageOrders(input: $input) {
      applicants {
        applicantId
        success
        errorMsg
        successMsg
      }
    }
  }
`

export const GET_DRIVER_IQ_POLL_DEBUG_URL = gql`
  query GET_DRIVER_IQ_POLL_DEBUG_URL($packageOrderId: String!) {
    driverIQPollDebugUrl(packageOrderId: $packageOrderId)
  }
`

export const REVIVE_DRIVER_IQ_ORDER_POLL = gql`
  mutation REVIVE_DRIVER_IQ_ORDER_POLL($packageOrderId: String!) {
    reviveDriverIQOrderPoll(packageOrderId: $packageOrderId) {
      packageOrderId
      status
      errorMessage
    }
  }
`
